import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { LoginService } from './login/login.service';
import notify from 'devextreme/ui/notify';

@Injectable()
export class AutorizadorGuard implements CanActivate {

  listaPermissao = [
      {Nome: '', Permissao: true},
      {Nome: 'contrato', Permissao: true},
      {Nome: 'contratos', Permissao: true},
      {Nome: 'cliente-tipo', Permissao: true},
      {Nome: 'autorizacao-tipo', Permissao: true},
      {Nome: 'linha-telefonica', Permissao: true},
      {Nome: 'operadora', Permissao: true},
      {Nome: 'cobranca-tipo', Permissao: true},
      {Nome: 'pessoa', Permissao: true},
      {Nome: 'assinante', Permissao: false},
      {Nome: 'assinantes', Permissao: false},
      {Nome: 'pais', Permissao: true},
      {Nome: 'estado', Permissao: true},
      {Nome: 'endereco-local-tipo', Permissao: true},
      {Nome: 'localidade', Permissao: true},
      {Nome: 'logradouro', Permissao: true},
      {Nome: 'logradouro-cep', Permissao: true},
      {Nome: 'bairro', Permissao: true},
      {Nome: 'empresa', Permissao: true},
      {Nome: 'filial', Permissao: true},
      {Nome: 'fornecedor', Permissao: true},
      {Nome: 'fabricante', Permissao: false},
      {Nome: 'equipe', Permissao: true},
      {Nome: 'tecnico', Permissao: true},
      {Nome: 'usuario-sistema', Permissao: true},
      {Nome: 'usuarios-sistema', Permissao: true},
      {Nome: 'banco-agencia', Permissao: true},
      {Nome: 'banco', Permissao: true},
      {Nome: 'usuario-grupo', Permissao: true},
      {Nome: 'religiao', Permissao: true},
      {Nome: 'profissao', Permissao: true},
      {Nome: 'produto', Permissao: true},
      {Nome: 'funcao-equipamento', Permissao: true},
      {Nome: 'produto-segmento', Permissao: true},
      {Nome: 'promocao', Permissao: true},
      {Nome: 'produto-promocao', Permissao: true},
      {Nome: 'produto-pacote', Permissao: true},
      {Nome: 'canal', Permissao: true},
      {Nome: 'item', Permissao: true},
      {Nome: 'item-serie', Permissao: true},
      {Nome: 'motivo-inativacao', Permissao: true},
      {Nome: 'protocolo-atendimento-tipo', Permissao: true},
      {Nome: 'protocolo-assunto', Permissao: true},
      {Nome: 'protocolo-tipo', Permissao: true},
      {Nome: 'protocolo-motivo', Permissao: true},
      {Nome: 'protocolo', Permissao: true},
      {Nome: 'protocolos', Permissao: true},
      {Nome: 'servico', Permissao: true},
      {Nome: 'ordens-servico', Permissao: true},
      {Nome: 'ordem-servico', Permissao: true},
      {Nome: 'motivo-cancelamento', Permissao: true}
  ];

  constructor(
    private loginService: LoginService,
    private router: Router
  ) {}

  canActivate(
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const urlSplitted = state.url.split('/');
    const url = urlSplitted[1];


    if (this.loginService.estaLogado() === true) {
      // Verifica se é superusuario ou se vai buscar permissoes do grupo.
      if ( localStorage.getItem('usuarioLogado') !== null ) {
        const usuarioLogado = JSON.parse(localStorage.getItem('usuarioLogado'));

        if ( usuarioLogado.usuarioSistema.SuperUsuario === 'S' ) {
          return true;
        } else {
          // verificar permissoes do grupo
          const permissao = this.listaPermissao.find((fItem) => fItem.Nome === url);

          if (( permissao !== undefined) && ( permissao.Permissao === true)) {
            return true;
          }
        }
      }
      notify('Permissão negada!', 'error', 2000);
      this.router.navigate(['/permissao-negada']);
      return false; // se não for SuperUsuario e também não tiver permissão do grupo, retornar false
    } else {
      notify('É necessário estar logado para acessar está página.', 'error', 2000);
      this.router.navigate(['/login']);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/autorizador.guard.ts